import(/* webpackMode: "eager", webpackExports: ["TimeZoneChangeDetector"] */ "/usr/local/src/rallly/apps/web/src/app/[locale]/timezone-change-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/local/src/rallly/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/usr/local/src/rallly/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/node_modules/tailwindcss/tailwind.css");
;
import(/* webpackMode: "eager" */ "/usr/local/src/rallly/apps/web/src/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/usr/local/src/rallly/packages/ui/src/toaster.tsx");
